import "./App.css";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import { AppProvider } from "./components/context/context";
import { WebSocketProvider } from "./context/WebSocketContext";
import AppInitializer from "./context/AppInitializer";
import AppRoutes from "./routes/AppRoutes";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  ArcElement,
  BarElement,
  RadialLinearScale,
  DoughnutController,
} from "chart.js";
import "chartjs-adapter-date-fns";
import KeyboardShortcuts from "./components/KeyboardShortcuts";
import StringHelpers from "./components/StringHelpers";

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  ArcElement,
  BarElement,
  RadialLinearScale,
  DoughnutController,
);

function App() {
  return (
    <div className="App">
      <AppProvider>
        <WebSocketProvider>
          <AppInitializer />
          <Router>
            <KeyboardShortcuts />
            <StringHelpers />
            <Routes>{AppRoutes()}</Routes>
          </Router>
        </WebSocketProvider>
      </AppProvider>
    </div>
  );
}

export default App;
